<template>
  <section>
    <v-card>
      <v-container fill-height fluid pa-2>
        <v-flex xs12 sm6 md4>
          <v-menu
            :close-on-content-click='false'
            v-model="fechaInicio"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateInicio"
              label="Seleccione fecha de inicio"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateInicio" @input="fechaInicio = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-menu
            :close-on-content-click="false"
            v-model="fechaFin"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFin"
              label="Seleccione fecha fin"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateFin" @input="fechaFin = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn :loading="loading4" :disabled="loading4" color="info" @click="objetoReporteConciliaciones()">
          generar Reporte
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </v-btn>
      </v-container>
      <v-container v-if="$util.isRol('DIRECTOR')" fill-height fluid pa-2>
        <v-flex>
          <v-radio-group v-model="tipo" column>
            <v-radio label="Nacional" value="nacional"></v-radio>
            <v-radio label="Departamental" value="departamental"></v-radio>
          </v-radio-group>
        </v-flex>

        <v-flex xs12 sm6 md4 v-if="tipo==='departamental'">
          <v-select
            v-model="select_departamento"
            :items="departamento"
            item-text="nombre"
            item-value="codigo"
            label="Departamento"
            persistent-hint
            return-object
          ></v-select>
        </v-flex>
      </v-container>
    </v-card>

    <v-container fluid grid-list-md>
      <v-toolbar flat color="#CFD8DC">
      <v-toolbar-title> CONCILIACIONES</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      </v-toolbar>
       <v-data-iterator
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        content-tag="v-layout"
        row
        wrap
      >
        <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
          <v-card :landscape="landscape">
            <v-card :color="props.item.color">
              <v-card-title class="blue--text">
                <h4>{{ props.item.name }}</h4>
              </v-card-title>
            </v-card>
            
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>NIÑO (A) (0-17):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['0-17'] }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>JOVENES (18-30):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['18-30']}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>ADULTOS (31-59):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['31-59'] }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>ADULTO MAYOR (60-99):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['60-99'] }}</v-list-tile-content>
              </v-list-tile>
            </v-list>

           
          </v-card>
        </v-flex>
      </v-data-iterator>
    </v-container>

    <v-container fluid grid-list-md>
      <v-toolbar flat color="#B39DDB">
      <v-toolbar-title> PATROCINIOS</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      </v-toolbar>
       <v-data-iterator
        :items="itemsP"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        content-tag="v-layout"
        row
        wrap
      >
        <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
          <v-card :landscape="landscape">
            <v-card :color="props.item.color">
              <v-card-title class="blue--text">
                <h4>{{ props.item.name }}</h4>
              </v-card-title>
            </v-card>
            
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>NIÑO (A) (0-17):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['0-17'] }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>JOVENES (18-30):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['18-30']}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>ADULTOS (31-59):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['31-59'] }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>ADULTO MAYOR (60-99):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['60-99'] }}</v-list-tile-content>
              </v-list-tile>
            </v-list>

           
          </v-card>
        </v-flex>
      </v-data-iterator>
    </v-container>
  </section>
</template>

<script>
import PieChart from './PieChart.js';

export default {
  components: {
    PieChart
  },
  mounted () {
    this.$service['get']('v1/dpas/departamentos').then(response => {
      if (response) {
        this.departamento = response;
      }
    });
  },
  data: () => ({
    rowsPerPageItems: [5, 10, 15],
    pagination: {
      rowsPerPage: 5
    },
    chartdata: null,
    options: null,
    landscape: false,
    dateInicio: new Date().toISOString().substr(0, 10),
    fechaInicio: false,
    dateFin: new Date().toISOString().substr(0, 10),
    fechaFin: false,
    loading4: false,
    items: [],
    itemsP: [],
    dataChart: [],
    checkbox: true,
    radioGroup: 1,
    nacional: null,
    departamental: null,
    tipo: null,
    select_departamento: { nombre: 'La Paz', codigo: '02' },
    headers: [
      {
        text: 'Dessert (100g serving)',
        align: 'left',
        sortable: false,
        value: 'name'
      },
      { text: 'Calories', value: 'calories' },
      { text: 'Fat (g)', value: 'fat' },
      { text: 'Carbs (g)', value: 'carbs' },
      { text: 'Protein (g)', value: 'protein' },
      { text: 'Iron (%)', value: 'iron' }
    ]
  }),
  methods: {
    objetoReporteConciliaciones () {
      let ruta;
      if (this.tipo === null) {
        ruta = `v1/conciliaciones/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${this.dateFin}`;
      }
      if (this.tipo === 'nacional') {
        ruta = `v1/conciliaciones/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${
        this.dateFin}&nal=true`;
      }
      if (this.tipo === 'departamental') {
        ruta = `v1/conciliaciones/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${
        this.dateFin}&dpa=${this.select_departamento.codigo}`;
      }
      this.$service['get'](ruta).then(response => {
        if (response) {
          this.items = response;
          const lista = response;
          const listaKeys = Object.keys(response);
          this.items = [];

          for (let i of listaKeys) {
            let el = {};
            el.name = i;
            el.name2 = Object.keys(i);
            el['0-17'] = lista[i]['0-17'];
            el['18-30'] = lista[i]['18-30'];
            el['31-59'] = lista[i]['31-59'];
            el['60-99'] = lista[i]['60-99'];
            this.items.push(el);
          }
          this.objetoReportePatrocinios();
        }
      });
    },
    objetoReportePatrocinios () {
      let rutaPath;
      if (this.tipo === null) {
        rutaPath = `v1/patrocinios/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${this.dateFin}`;
      }
      if (this.tipo === 'nacional') {
        rutaPath = `v1/patrocinios/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${
        this.dateFin}&nacional=true`;
      }
      if (this.tipo === 'departamental') {
        rutaPath = `v1/patrocinios/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${
        this.dateFin}&dpa=${this.select_departamento.codigo}`;
      }
      this.$service['get'](rutaPath).then(response => {
        if (response) {
          this.itemsP = response;
          const lista = response;
          const listaKeys = Object.keys(response);
          this.itemsP = [];

          for (let i of listaKeys) {
            let el = {};
            el.name = i;
            el['0-17'] = lista[i]['0-17'];
            el['18-30'] = lista[i]['18-30'];
            el['31-59'] = lista[i]['31-59'];
            el['60-99'] = lista[i]['60-99'];
            this.itemsP.push(el);
          }
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/reportes/EdadMateria.vue